import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../contexts/ThemeContext';

const Footer: React.FC = () => {
  const { isDark } = useTheme();
  const currentYear = new Date().getFullYear();
  const copyrightYear = currentYear === 2025 ? '2025' : `2025-${currentYear}`;

  return (
    <footer
      className={`py-8 sm:py-12 border-t ${
        isDark ? 'bg-gray-900 border-gray-800' : 'bg-white border-gray-200'
      }`}
      role="contentinfo"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center mb-3 sm:mb-4">
              <div>
                <h3 className="text-3xl sm:text-xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 dark:from-blue-400 dark:to-purple-400 bg-clip-text text-transparent">
                  Upmindy
                </h3>
                <p className="text-xs text-gray-500 dark:text-gray-400 font-medium tracking-wide uppercase">
                  Learning Platform
                </p>
              </div>
            </div>
            <p className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
              Somos a Upmindy, uma plataforma que torna o aprendizado mais simples e dinâmico. Reunimos flashcards, quizzes, jogos e módulos de estudo para ajudar você a aprender no seu ritmo.
            </p>
          </div>

          <div>
            <h4 className="font-semibold mb-3 sm:mb-4 text-sm sm:text-base">Ferramentas</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/docs/flashcards" className="text-sm sm:text-base text-gray-600 dark:text-gray-300 hover:text-blue-600 transition-colors">
                  Flashcards
                </Link>
              </li>
              <li>
                <Link to="/docs/quizzes" className="text-sm sm:text-base text-gray-600 dark:text-gray-300 hover:text-blue-600 transition-colors">
                  Quizzes
                </Link>
              </li>
              <li>
                <Link to="/feature/match-game" className="text-sm sm:text-base text-gray-600 dark:text-gray-300 hover:text-blue-600 transition-colors">
                  Matches
                </Link>
              </li>
              <li>
                <Link to="/docs/studies" className="text-sm sm:text-base text-gray-600 dark:text-gray-300 hover:text-blue-600 transition-colors">
                  Estudos
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-3 sm:mb-4 text-sm sm:text-base">Conteúdo</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/blog" className="text-sm sm:text-base text-gray-600 dark:text-gray-300 hover:text-blue-600 transition-colors">
                  Blog
                </Link>
              </li>
              <li>
                <Link to="/search" className="text-sm sm:text-base text-gray-600 dark:text-gray-300 hover:text-blue-600 transition-colors">
                  Explorar Recursos
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-3 sm:mb-4 text-sm sm:text-base">Recursos</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy-policy" className="text-sm sm:text-base text-gray-600 dark:text-gray-300 hover:text-blue-600 transition-colors">
                  Privacidade
                </Link>
              </li>
              <li>
                <Link to="/terms-of-service" className="text-sm sm:text-base text-gray-600 dark:text-gray-300 hover:text-blue-600 transition-colors">
                  Termos de Uso
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-300 dark:border-gray-700 mt-6 sm:mt-8 pt-6 sm:pt-8 text-center">
          <p className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
            © {copyrightYear} Upmindy. Todos os direitos reservados.
          </p>
          <p className="mt-2 text-sm text-gray-500 dark:text-gray-400">
            Aprendizado Adaptativo • Algoritmos de Retenção • Gamificação
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
